import { useTranslation } from 'react-i18next';

/**
 * Tela mostrada quando o ErrorBoundary do Sentry pega um erro não tratado.
 * Usa CSS inline pra independência total — funciona mesmo se o tema falhar.
 */
export default function ErrorFallback({ error, resetError }) {
  const { t } = useTranslation();
  const mensagem = error instanceof Error ? error.message : String(error);
  const handleRecarregar = () => window.location.reload();

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.iconWrap}>
          <svg
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#d32f2f"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
        </div>
        <h1 style={styles.titulo}>{t('erroFatal.titulo')}</h1>
        <p style={styles.descricao}>{t('erroFatal.texto')}</p>

        <details style={styles.detalhes}>
          <summary style={styles.detalhesSummary}>{t('erroFatal.detalhes')}</summary>
          <pre style={styles.erro}>{mensagem}</pre>
        </details>

        <div style={styles.acoes}>
          <button style={styles.botaoPrimario} onClick={resetError}>
            {t('erroFatal.tentarNovamente')}
          </button>
          <button style={styles.botaoSecundario} onClick={handleRecarregar}>
            {t('erroFatal.recarregar')}
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
    backgroundColor: '#f5f7fa',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  card: {
    maxWidth: 520,
    width: '100%',
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 40,
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.08)',
    textAlign: 'center',
  },
  iconWrap: {
    width: 80,
    height: 80,
    borderRadius: '50%',
    backgroundColor: '#ffebee',
    margin: '0 auto 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  titulo: { margin: '0 0 8px', fontSize: 24, fontWeight: 600, color: '#1a1a1a' },
  descricao: { margin: '0 0 24px', fontSize: 14, color: '#666', lineHeight: 1.6 },
  detalhes: {
    marginBottom: 24,
    textAlign: 'left',
    border: '1px solid #e0e0e0',
    borderRadius: 8,
    padding: 12,
    backgroundColor: '#fafafa',
  },
  detalhesSummary: { cursor: 'pointer', fontSize: 13, color: '#666', fontWeight: 500 },
  erro: {
    margin: '12px 0 0',
    fontSize: 12,
    color: '#d32f2f',
    fontFamily: 'ui-monospace, SFMono-Regular, monospace',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  acoes: { display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' },
  botaoPrimario: {
    padding: '10px 20px',
    fontSize: 14,
    fontWeight: 500,
    color: '#fff',
    backgroundColor: '#3949AB',
    border: 'none',
    borderRadius: 6,
    cursor: 'pointer',
  },
  botaoSecundario: {
    padding: '10px 20px',
    fontSize: 14,
    fontWeight: 500,
    color: '#3949AB',
    backgroundColor: 'transparent',
    border: '1px solid #3949AB',
    borderRadius: 6,
    cursor: 'pointer',
  },
};
